import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiTwotoneStar } from "react-icons/ai";

function Footer() {
  return (
    <div className="footer-pin">
    <Container fluid className="footer">
      <Row>
        <Col md="4">
        </Col>
        <Col md="8" className="footer-body">
        <h5 className="float-end">Theme by @gradualcolors <AiTwotoneStar />
        </h5>
        </Col>
      </Row>
    </Container>
    </div>
  );
}

export default Footer;
